<template>
  <div class="container">
    <h1>
      <button
        type="button"
        tabindex="1"
        class="btn"
        title="Back"
        aria-label="Back"
        @click="advance"
        @keyup.enter="advance"
      >
        <Tcon icon="f-chevron-left" class="chevron-left" /></button
      >Available Offers
    </h1>
    <div v-if="!loadingStore.isOffersAsyncing && currOffers.length === 0" class="error-msg">
      <p class="error-message">There are no active offers in this campaign</p>
    </div>
    <div class="card-group" deck v-else>
      <Card
        v-on="$listeners"
        v-for="offer in currOffers"
        :key="offer.offer_id"
        :data="offer"
        type="offer"
        :id="offer.offer_id"
        :name="offer.name"
        :start_date="offer.start_date"
        :end_date="offer.end_date"
        :description="offer.offer_desc_en"
        :step="step"
        :selfOptin="selfOptin"
        :custSignup="custSignup"
        :isDisabled="offer.status !== 'Active'"
      />
    </div>
  </div>
</template>

<script>
import Card from "./Card";
import axios from "axios";
import Tcon from "../iconography/Tcon";
import { LoadingStore } from "@/store/LoadingStore.js";

export default {
  name: "Offers",
  components: {
    Card,
    Tcon,
  },
  props: {
    step: Number,
    id: Number,
    offers: Array,
    selfOptin: Boolean,
    custSignup: Boolean,
  },
  data() {
    return {
      loadingStore: LoadingStore(),
      currStep: this.step,
      currOffers: [],
      config: {
        headers: { "timezone-offset": new Date().getTimezoneOffset() / 60 },
      },
    };
  },
  created() {
    if (this.offers) {
      this.currOffers = this.offers;
    } else {
      this.getOffers();
    }
  },
  methods: {
    showExpired(exp) {
      this.$emit("showExpired", exp);
    },
    getOffers() {
      this.loadingStore.isOffersAsyncing = true;
      this.loadingStore.type = "form";
      this.loadingStore.isLoading = true;
      axios
        .get(
          `admin/offers?campaignID=${
            this.id
          }&daysExpired=7&onlyEnabledCCAccess=1`,
          this.config
        )
        .then((response) => {
          if (response.data) {
            this.currOffers = response.data.filter(function(el) {
              return el.status === "Active" || el.status === "Ended";
            });
          } else {
            this.currOffers = [];
          }
          this.$emit("load", this.currOffers);
        })
        .catch((error) => {
          console.error(error);
          // Auth and Cookie errors get caught by interceptor, other errors should route to error page
          setTimeout(() => {
            let errorMsg = error.response.data.UserMsgMap;
            this.$router.replace({ name: "error", params: { errorMsg } });
          }, 1000);
        })
        .finally(() => {
          this.loadingStore.isOffersAsyncing = false;
          this.loadingStore.isLoading = false;
        });
    },
    advance() {
      this.$emit("advance", [2]);
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: left;
}

.error-msg {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  margin: auto;
}

h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.chevron-left {
  height: 2rem;
  width: 2rem;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;
}

i {
  cursor: pointer;
}

.test {
  background-color: red;
}
</style>
